// Minimal view-definition primitives the copied CRM modules depend on. In ptc-core CRM these
// live in a larger viewDefinition module; tax-lifecycle only needs the two symbols
// useListSearchParams imports, so they are provided here to keep that copy verbatim.

/**
 * The default page size. A `pageSize` equal to this is OMITTED from the URL (canonical
 * default). Tax-lifecycle's DataTable defaults its page size to 25, so 25 is the omitted value.
 */
export const DEFAULT_PAGE_SIZE = 25;

/** Explicit sort override carried in the URL (`sort=<col>&dir=<asc|desc>`). */
export interface ViewSort {
  col: string;
  dir: 'asc' | 'desc';
}
